import { render, staticRenderFns } from "./AddHospital.vue?vue&type=template&id=78ff8668&scoped=true"
import script from "./AddHospital.vue?vue&type=script&lang=js"
export * from "./AddHospital.vue?vue&type=script&lang=js"
import style0 from "./AddHospital.vue?vue&type=style&index=0&id=78ff8668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ff8668",
  null
  
)

export default component.exports